// extracted by mini-css-extract-plugin
module.exports = {"root":"EditSocialDescriptionPanel_root__1Lrsz","form":"EditSocialDescriptionPanel_form__2cWX9","title":"EditSocialDescriptionPanel_title__1FM3D"};